import { AppState } from 'types/app';

export const selectPathname = (state: AppState) => state.router.location.pathname;
